<template>
	<div class="footer">

		<div class="flex-Vert foot__Inner">
			<div class="flex-Hori row-01">
				<div class="flex-Hori linkList">
					<div v-for="(colDataObj, i_ColDataArr) of footerData" :key="i_ColDataArr" class="flex-Vert">
						<div
							v-for="(item, i_ColData) of colDataObj.colData" :key="i_ColData"
							class="item"
							@click="item.url && openArticle(item)"
						>{{item.name}}</div>
					</div>
				</div>
				<div class="flex-Hori QRCodeList">
					<!-- 奢享汇公众号QRCode -->
					<!-- <div class="item"><img src="https://sxh-1253575465.file.myqcloud.com/Integer_shop/img/1691573182kWIg.jpg" /></div> -->
					<!-- 汇奢享公众号QRCode -->
					<div class="item"><img src="https://sxh-1253575465.file.myqcloud.com/Integer_shop/img/1692852959GuCI.jpg" /></div>
					<!-- 汇奢享小程序QRCode -->
					<div class="item"><img src="https://sxh-1253575465.file.myqcloud.com/Integer_shop/img/1693394302gtew.png" /></div>
				</div>
			</div>

			<div class="flex-Hori row-02">
				<div class="flex-Hori left">
					<div class="item">客服：<span>周一到周日9:00-20:00 (北京时间)</span></div>
					<div class="item">邮件：<span>service@qxtec.com.cn</span></div>
					<div class="item">ICP备案证书号:<a href="http://beian.miit.gov.cn/" target="_blank" style="color: #fff;">浙ICP备20001286号-1</a></div>
					<div class="item">版权所有 杭州趣讯电子商务有限公司</div>
				</div>
				<div class="flex-Hori right">
					<span class="title">支付方式：</span>
					<!-- <img src="../../../static/img/payments-Alipay.png" /> -->
					<img src="../../../static/img/payments-WechatPay.png" />
					<!-- <img src="../../../static/img/payments-UnionPay.png" /> -->
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import bus, { Evt_Footer } from '../../assets/bus'

	export default {
		data() {
			return {
			}
		},
		computed: {
			...mapGetters([
				'footerData'
			]),
		},
		created() {
			this.getArticleIds()
		},
		methods:{
			getArticleIds() {
				this.$server.get('https://apis.quxun.co/API/PCAPI/index.php/AppInterface/Article/ids', {

				})
				.then(res => {
					for(const col of this.footerData) {
						for(const [i, item] of col.colData.entries()) {
							const target = res.data.find(it => it.id === item.id)
							if(target) {
								item.url = target.url
							}
						}
					}
					bus.$emit(Evt_Footer.Update_ArticleIds)
				})
				.catch(res => {
					console.error('getArticleIds: error =>', res)
					this.$message.error(this.$t('common.require-error'))
				})
			},
			openArticle(item) {
				const { url, id } = item
				// const arr = url.split('/')
				// const id = arr[arr.length - 1]

				const param = {
					path:"/article",
					query:{
						id
					}
				}
				// this.$router.push(param)
				bus.$emit('goProduct', param)
			}
		}
	}
</script>

<style lang="scss">
	.footer {
		// position: absolute;
		// display: flex;
		// align-items: center;
		// justify-content: center;
		// flex-direction: column;
		width: 100%;
		// height: 100px;
		// left: 0;
		// bottom: 0;
		background-color: $color-PageFooter;
		color: #fff;
		font-size: 12px;

		p{
			margin-bottom: 5px;
			a{
				color: #fff;
			}
		}
		.foot__Inner {
			// width: 1024px;
			margin: 0 auto;

			@mixin row_Base() {
				width: 100%;
				box-sizing: border-box;
				padding: 32px calc((100% - 1000px) / 2) 0;
			}
			.row-01 {
				@include row_Base();
				align-items: flex-start;
				padding-top: 20px;
				padding-bottom: 16px;
				border-bottom: 1px solid #aaa6;

				$linkList-Item-Pad: 4px;
				.linkList {
					$w: 128px;
					align-items: flex-start;
					margin-bottom: 6px;
					white-space: nowrap;

					.item {
						max-width: $w;
						min-width: $w;
						padding: $linkList-Item-Pad 0 $linkList-Item-Pad;
						margin-bottom: 10px;
						font-size: 12px;
						line-height: 1em;
						cursor: pointer;

						&:first-of-type {
							margin-bottom: 16px;
							font-size: 14px;
							font-weight: bold;
						}
					}
				}
				.QRCodeList {
					width: 100%;
					// margin-top: $linkList-Item-Pad * 2;
					margin-left: 48px;
					justify-content: flex-start;

					.item {
						width: 128px;
						height: 128px;
						margin-left: 48px;

						&:first-of-type {
							margin-left: 0;
						}
						img {
							width: 100%;
							object-fit: contain;
						}
					}
				}
			}
			.row-02 {
				@include row_Base();
				justify-content: flex-start;
				padding-top: 0;

				.left {
					flex-direction: row;
					flex-wrap: wrap;
					width: $container-MinWidth / 2;
					min-width: $container-MinWidth / 2;
					box-sizing: border-box;
					padding: 12px 0 32px;
					align-items: flex-start;
					white-space: nowrap;
					border-right: 1px solid #aaa6;
					font-size: 13px;
					line-height: 24px;

					.item {
						width: 255px;
					}
				}
				.right {
					justify-content: center;
					width: $container-MinWidth / 2;
					min-width: $container-MinWidth / 2;

					.title {
						margin-right: 12px;
					}
					img {
						width: 32px;
						height: 32px;
						margin-right: 16px;
					}
				}
			}

		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Common/Footer.vue